export const ACTION_TYPES = {
  ON_ROW_EXPAND_CLICK: 'ON_ROW_EXPAND_CLICK',
  HANDLE_EXPAND_CHANGE: 'HANDLE_EXPAND_CHANGE',
  ON_SEND_EMAIL_CLICK: 'ON_SEND_EMAIL_CLICK',
};
